import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FuzzyActions } from 'actions';
import Fuzzy from 'components/Fields/Fuzzy';

function mapDispatchToProps(dispatch) {
    return {
        getFuzzy: bindActionCreators(FuzzyActions, dispatch).getFuzzy,
    };
}

class FuzzySearch extends PureComponent {
    constructor(props) {
        super(props);
        this.debounce = null;
        this.cachedOptions = {};
    }

    componentDidUpdate(prevProps) {
        const { list } = this.props;
        if (list !== prevProps.list) {
            this.cachedOptions = {};
        }
    }

    fetchOptions = (text) => {
        const { getFuzzy, onFetchOptions, list, field, feature } = this.props;

        if (onFetchOptions) {
            return onFetchOptions({
                list,
                field,
                text,
                feature,
            });
        }
        return getFuzzy({
            list,
            text,
        });
    };

    loadOptions = (text, cb) => {
        const finalText = text || '';
        if (this.cachedOptions[finalText]) {
            return cb(this.cachedOptions[finalText]);
        }
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.fetchOptions(finalText)
                .then((results) => {
                    this.cachedOptions[finalText] = results;
                    cb(results);
                })
                .catch();
        }, 500);
        return null;
    };

    render() {
        return <Fuzzy loadOptions={this.loadOptions} {...this.props} />;
    }
}

FuzzySearch.propTypes = {
    getFuzzy: PropTypes.func.isRequired,
    onFetchOptions: PropTypes.func, // Custom load options
    list: PropTypes.string,
    field: PropTypes.shape({}),
    feature: PropTypes.shape({}),
    onChange: PropTypes.func,
    defaultOptions: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(FuzzySearch);
